import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

const DetailNav = (props) => {
  const { match } = props;

  return (
    <div className="detail-tabs">
      <NavLink
        exact
        to={`/backpack-buddy/schools/${match.params.id}`}
        activeClassName="active"
        className="account-links w-inline-block"
      >
        <div>School Profile</div>
      </NavLink>
      <NavLink
        exact
        to={`/backpack-buddy/schools/${match.params.id}/contacts`}
        activeClassName="active"
        className="account-links w-inline-block"
      >
        <div>Contacts</div>
      </NavLink>
      <NavLink
        exact
        to={`/backpack-buddy/schools/${match.params.id}/program-status`}
        activeClassName="active"
        className="account-links w-inline-block"
      >
        <div>Program Status</div>
      </NavLink>
      <NavLink
        exact
        to={`/backpack-buddy/schools/${match.params.id}/allocate`}
        activeClassName="active"
        className="account-links w-inline-block"
      >
        <div>Allocate</div>
      </NavLink>
      <NavLink
        exact
        to={`/backpack-buddy/schools/${match.params.id}/reports`}
        activeClassName="active"
        className="account-links w-inline-block"
      >
        <div>Reports</div>
      </NavLink>
      <NavLink
        exact
        to={`/backpack-buddy/schools/${match.params.id}/food-safety`}
        activeClassName="active"
        className="account-links w-inline-block"
      >
        <div>Food Safety</div>
      </NavLink>
      <NavLink
        exact
        to={`/backpack-buddy/schools/${match.params.id}/applications`}
        activeClassName="active"
        className="account-links w-inline-block"
      >
        <div>Applications</div>
      </NavLink>
    </div>
  );
};

DetailNav.propTypes = {
  match: PropTypes.object.isRequired,
};

export default DetailNav;
